import pick from 'lodash/pick';
import get from 'lodash/get';
import { parseStringToNumber } from 'utils/number';
import { getMomentDate, getBEDate, getLast5Years } from 'utils/date';
import { getFileFieldInitialValues } from 'utils/form';
import { getOtherDataValue } from 'utils/customField';
import {
  FILE_FIELDS,
  DATE_FIELDS,
  NORMAL_FIELDS,
  NULL_FIELDS,
  BODY_REQUEST_NORMAL_FIELDS,
  NUMBER_FIELDS,
} from '../tabConstants/general';

const getFileField = field => {
  if (!field) return '';
  return field
    .replace('documents.', '')
    .replace('BOC3.', '')
    .replace('SCAC.', '');
};
const getFileYearInitialValues = (keys = [], data) => {
  const initialValues = {};
  const listYears = getLast5Years();
  listYears.forEach(year => {
    keys.forEach(key => {
      const fileObj = get(
        data,
        `documents.${key.toUpperCase()}.${year}.${`${key}_year_wise`}`
      )?.[0];
      initialValues[`${key}_year_wise_${year}`] = fileObj
        ? fileObj.id
          ? [
              {
                ...fileObj,
                uid: fileObj.id,
              },
            ]
          : fileObj.map(f => ({
              ...f,
              uid: f.id,
            }))
        : null;
    });
  });
  return initialValues;
};

export const getInitialValues = data => {
  const initialValues = {
    delete_attachments: [],
    delete_custom_fields: [],
    other: getOtherDataValue(data?.custom_fields || []),
  };
  [...NORMAL_FIELDS, ...NULL_FIELDS].map(field => {
    const eValue = data[field];
    initialValues[field] = eValue || (NULL_FIELDS.includes(field) ? null : '');
    return true;
  });
  DATE_FIELDS.map(field => {
    initialValues[field] = data[field]
      ? getMomentDate(data[field], false, true)
      : '';
    return true;
  });
  const returnObj = {
    ...initialValues,
    ...getFileFieldInitialValues(FILE_FIELDS, data, 'documents', [
      'BOC3',
      'SCAC',
    ]),
    ...getFileYearInitialValues(['ucr', '2290'], data),
  };

  return returnObj;
};

export const getGeneralBR = (values = {}) => {
  const { delete_attachments, other, delete_custom_fields } = values;
  const bodyRequest = {
    ...pick(values, BODY_REQUEST_NORMAL_FIELDS),
  };
  DATE_FIELDS.map(field => {
    bodyRequest[field] = values[field] ? getBEDate(values[field]) : '';
    return true;
  });
  NUMBER_FIELDS.map(field => {
    bodyRequest[field] = parseStringToNumber(values[field]);
    return true;
  });
  const fData = new FormData();
  Object.keys(bodyRequest).map(k => {
    fData.append(
      k,
      bodyRequest[k] || bodyRequest[k] === 0 ? bodyRequest[k] : ''
    );
    return true;
  });
  FILE_FIELDS.map(originKey => {
    const key = getFileField(originKey);
    if (values[key] && values[key].length > 0) {
      values[key].map(file => {
        if (file.originFileObj && !file.id) {
          fData.append(`${key}[]`, file.originFileObj);
        }
        return true;
      });
    } else {
      fData.append(key, '');
    }
    return true;
  });
  if (delete_attachments && delete_attachments.length > 0) {
    delete_attachments.map(id => {
      fData.append('delete_documents[]', id);
      return true;
    });
  }
  if (other && other.length > 0) {
    other.map((field, index) => {
      fData.append(`custom_fields[${index}][field_name]`, field.field_name);
      if (field.originId) {
        fData.append(`custom_fields[${index}][id]`, field.originId);
      }
      const firstDocument = get(field, 'document[0]') || null;
      const existingFileName = get(field, 'originData.document_name', '');
      if (firstDocument && !firstDocument.url) {
        fData.append(
          `custom_fields[${index}][document]`,
          firstDocument.originFileObj
        );
      } else if (!firstDocument && !!existingFileName) {
        fData.append(`custom_fields[${index}][document_delete]`, 1);
      }
      return true;
    });
  } else {
    fData.append('custom_fields', '');
  }
  if (delete_custom_fields && delete_custom_fields.length > 0) {
    delete_custom_fields.map(id => {
      fData.append('delete_custom_fields[]', id);
      return true;
    });
  }
  return fData;
};
